import React from "react";
import "../../../App.css";
import "./BecomeAgent.css";
import laptopicon from "../../Assets/laptop-clone.svg";
import phoneicon from "../../Assets/phone-icon.svg";
import blueblob from "../../Assets/blue Ellipse.svg";
import ashblob from "../../Assets/ash Ellipse.svg";

const GetStarted = () => {
  return (
    <>
      <div className="get-started-section">
        <div className="get-started-container">
          <div className="get-started-main">
            <div className="get-started-header">
              <img src={laptopicon} alt="laptop-mock" className="laptop-mock" />
              <img src={phoneicon} alt="phone-mock" className="phone-mock" />
            </div>
            <div className="way-to-start-main">
              <div className="way-to-start-section">
                <h5 className="way-to-start-heading">
                  A Simple Way to Get Started
                </h5>
              </div>
              <div className="way-to-start-flex-section mt-5">
                <div>
                  <img src={blueblob} alt="" className="blue-blob" />
                  <div className="dashed-img"></div>
                </div>
                <div className="register-free-header">
                  <h5 className="register-free-h5">
                  Send an application mail
                  </h5>
                  <p className="register-free-p" style={{display:'block'}}>
                  Send a detailed application
                   mail to <a href="mailto:hello@myovest.com"> hello@myovest.com.
                    </a> stating reasons why you want to become an OVest agent, past experiences and what you have to offer 
                  </p>
                </div>
              </div>
              <div className="way-to-start-flex-section">
                <div>
                  <img src={ashblob} alt="" className="ash-blob" />
                  <div className="dashed-img"></div>
                </div>
                <div className="register-free-header">
                  <h5 className="register-free-h5">
                  Application Review
                  </h5>
                  <p className="register-free-p">
                  Your application mail will be reviewed, after which you will receive a response mail 
                  </p>
                </div>
              </div>{" "}
              <div className="way-to-start-flex-section">
                <div>
                  <img src={ashblob} alt="" className="ash-blob" />
                  <div className="dashed-img"></div>
                </div>
                <div className="register-free-header">
                  <h5 className="register-free-h5">Offer Mail</h5>
                  <p className="register-free-p">
                  If you have been accepted, follow the instructions on the response mail, you will receive a link that 
                  directs you to the agents page where you will fill a form.
                  </p>
                </div>
              </div>
              <div className="way-to-start-flex-section">
                <div>
                  <img src={ashblob} alt="" className="ash-blob" />
                </div>
                <div className="register-free-header">
                  <h5 className="register-free-h5">Join Telegram Community</h5>
                  <p className="register-free-last-p">
                  Come learn more about OVest and interact with other agents.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default GetStarted;
